// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const DimensionRowOut = zod.object({
  "axis": zod.union([zod.enum(['impact', 'feasibility']),zod.null()]).optional(),
  "description": zod.string(),
  "key": zod.string(),
  "label": zod.string(),
  "position": zod.int(),
  "retired_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "weight": zod.int()
});

export type DimensionRowOut = zod.input<typeof DimensionRowOut>;
export type DimensionRowOutOutput = zod.output<typeof DimensionRowOut>;
